import React, { useEffect } from 'react';
import styled from 'styled-components';
import { RESPONSIVE_QUERY } from '@pass-frontend/utility/style-helpers';
import { FacilityHeader } from '../facility-header/facility-header';

const WidthConstrainer = styled.div`
  max-width: 1272px;
  margin: 0 auto;
  height: 100vh;
  ${RESPONSIVE_QUERY.large} {
    width: 90%;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
`;

const SignInButton = styled.button`
  background-color: #0066cc;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 24px;

  &:hover {
    background-color: #004499;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const debugLog = (operation: string, data: Record<string, unknown>) => {
  console.log(`[FacilityLogout] ${operation}:`, {
    timestamp: new Date().toISOString(),
    currentUrl: typeof window !== 'undefined' ? window.location.href : 'SSR',
    ...data,
  });
};

export function FacilityLogout() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    debugLog('Component mounted', {
      hasSearchParams: !!window.location.search,
    });

    // Check for any session tokens in URL and clear them
    const urlParams = new URLSearchParams(window.location.search);
    const hasSessionToken = urlParams.has('sessionToken');

    if (hasSessionToken) {
      debugLog('Found session token in URL, cleaning up', {});

      // Clean up the URL by removing token parameters
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete('sessionToken');
      window.history.replaceState({}, '', newUrl.toString());

      debugLog('URL cleaned up', {});
    }

    debugLog('Logout initialization complete', {
      sessionCleanupNeeded: hasSessionToken,
    });
  }, []);

  const handleSignIn = () => {
    if (typeof window === 'undefined') return;

    debugLog('Redirecting to sign-in', {});
    window.location.href = '/facility-sign-in';
  };

  return (
    <>
      <FacilityHeader shouldHideSignInButton={true} />
      <div className="has-rds-mb-none has-rds-bg-grey-lightest">
        <div className="has-rds-bg-grey-lightest has-rds-pb-64">
          <WidthConstrainer className="has-rds-pv-40">
            <ContentWrapper>
              <h1 className="is-rds-h1 has-rds-pv-40 has-text-centered">
                You have signed out
              </h1>
              <p className="is-rds-body-large has-text-centered has-rds-mb-24">
                Thank you for using the facility partner portal. You have been
                successfully signed out.
              </p>
              <SignInButton onClick={handleSignIn}>Sign In Again</SignInButton>
            </ContentWrapper>
          </WidthConstrainer>
        </div>
      </div>
    </>
  );
}
